"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KeyValueError = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _axios = _interopRequireDefault(require("axios"));
var _basic = _interopRequireDefault(require("./_basic"));
var _error = require("./error");
class KeyValueError extends _error.BasicError {
  /**
   * @constructor
   */
  constructor(error, data) {
    super('KeyValye API Error', error, data);
  }
}
exports.KeyValueError = KeyValueError;
class KeyValueApi extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      sdkApiUrl,
      accountId
    } = _ref;
    super({
      userTokenFactory
    });
    this.sdkApiUrl = sdkApiUrl;
    this.accountId = accountId;
    this.axios = _axios.default.create({
      baseURL: this.accountId ? `${this.sdkApiUrl}/accounts/${this.accountId}` : this.sdkApiUrl
    });
  }
  async _callApi(_ref2) {
    let {
      method,
      path = '',
      payload,
      queryParams,
      errorData = {}
    } = _ref2;
    const {
      headers
    } = await this.getHeaders();
    try {
      const {
        data: responseBody
      } = await this.axios({
        method,
        url: path,
        data: JSON.stringify(payload),
        params: queryParams,
        headers
      });
      return responseBody;
    } catch (error) {
      throw new KeyValueError(error, {
        statusCode: _lodash.default.get(error, 'response.status'),
        ...errorData
      });
    }
  }

  /**
   * Get all tables
   * @async
   */
  async listAllTables(next, maxKeys) {
    let prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return await this._callApi({
      method: 'get',
      path: '/storage',
      queryParams: {
        next,
        maxKeys,
        prefix
      }
    });
  }

  /**
   * Get value by Index
   * @async
   */
  async getValueByIndex(table, name, value) {
    return await this._callApi({
      method: 'get',
      path: `/storage-by-index/${table}`,
      queryParams: {
        name,
        value
      }
    });
  }

  /**
   * Process multiple items
   * @async
   */
  async processMultiple(keys, method, table) {
    return await this._callApi({
      method: 'post',
      path: '/storage-multiple',
      payload: {
        keys,
        method,
        table
      }
    });
  }
  async listTableKeys(table, _ref3) {
    let {
      next,
      maxKeys,
      prefix,
      delimiter,
      withValues = false
    } = _ref3;
    return await this._callApi({
      method: 'get',
      path: `/storage/${table}`,
      queryParams: {
        next,
        maxKeys,
        prefix,
        delimiter,
        withValues
      }
    });
  }
  async getValueByKey(table, key) {
    let exists = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return await this._callApi({
      method: 'get',
      path: `/storage/${table}/${key}`,
      queryParams: {
        exists
      }
    });
  }
  async setValueByKey(table, key, value, expire) {
    return await this._callApi({
      method: 'post',
      path: `/storage/${table}/${key}`,
      payload: {
        value,
        expire
      }
    });
  }
  async deleteValueByKey(table, key) {
    return await this._callApi({
      method: 'delete',
      path: `/storage/${table}/${key}`
    });
  }
}
var _default = KeyValueApi;
exports.default = _default;